window.appConstants = {
    "AppName": "CloudOpsGuru",
    "Allow": "COG",
    "CodeAndTechReadmesUrl": "https://qlg9ntv5k6.execute-api.us-west-2.amazonaws.com/dev",
    "clicklogUrl": "https://fm6vmiafu6.execute-api.us-east-1.amazonaws.com/test/clicklogger",
    "enableClickLogs": true,
    "blogUrl": "http://blog.codeandtech.com/"
}

